import React from 'react';
import { Client } from '../../Client';
import Spinner from '../Spinner/Spinner';

class AdminContainer extends React.Component {
	state = {
		inProgress: false,
		user_count: '',
	}



	loadStats = () => {
		this.setState({ inProgress: true });
		Client.get('/api/admin/stats', (serverStats) => {
			// console.log("Server Ops", serverStats);
			this.setState({
				user_count: serverStats.user_count || '',
				inProgress: false,
				success: serverStats.success,
			})
		}).catch((err) => {
			this.setState({ inProgress: false });
		});
	};



	componentDidMount() {
		this.loadStats();
	}



	renderResults() {
		if (this.state.success) return (
			<div>
				<div className="row">
					<div className="col-md-10 offset-md-1">

						<div className="card">
							<div className="card-block">
								<h2>Admin: User Stats</h2>
								<p style={{fontSize: 18}}>
									For admin users only, this screen shows some basic user stats.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12 offset-md-1">
						<div className="row">
							<div className="col-md-4">
								<div className="mt-4">
									<div className="caard-block text-center">
										<img src="/assets/img/icon-users.svg" className="img-responsive" style={{maxHeight: 150, marginTop: `2em`}} alt="Mental Health Advice"/>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="card">
									<div className="card-block text-center mt-4 mb-3">
										<h2 style={{ fontWeight: 800 }}>{ this.state.user_count }</h2>
										<p className="mt-2" style={{ fontWeight: 600 }}>Total Users</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		);
		else return (
			<div>
				<div className="row">
					<div className="col-md-10 offset-md-1">

						<div className="card">
							<div className="card-block">
								<h2>Not permitted</h2>
								<p style={{fontSize: 18}}>
									You don't have permission to access this resource
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		);


	}


	render() {

		return (
			<div className="container page-dashboard">
				{ this.state.inProgress ? (
					<Spinner/>
					) : (
					<div>
						{ this.renderResults() }
					</div>
				) }
			</div>
		);
	}
}




export default AdminContainer;




// WEBPACK FOOTER //
// ./src/js/components/containers/AdminContainer.js